import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { IndexdbLastupdateService } from '../data/repository/indexdb-lastupdate/indexdb-lastupdate.service';
import { phoneNumberUrl, introUrl, registerUrl } from '../global-variables';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private IndexdbLastupdateService: IndexdbLastupdateService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (localStorage.getItem('user')) {
      // logged in so return true
      // if (
      //   user.name == '' ||
      //   user.height == '' ||
      //   user.weight == '' ||
      //   user.birthDate == '' ||
      //   user.sex == '' ||
      //   !user.height ||
      //   !user.name ||
      //   !user.weight ||
      //   !user.birthDate ||
      //   !user.sex
      // ) {
      //   this.router.navigate([registerUrl + '/' + 'register-again'], {
      //     queryParams: { returnUrl: state.url },
      //   });
      //   return false;
      // } else {
      this.IndexdbLastupdateService.initial();
      return true;
      // }
    }

    // not logged in so redirect to login page with the return url
    if (localStorage.getItem('no-need-intro')) {
      this.router.navigate([phoneNumberUrl], {
        queryParams: { returnUrl: state.url },
      });
    } else {
      this.router.navigate([introUrl], {
        queryParams: { returnUrl: state.url },
      });
    }
    return false;
  }
}
